import React from 'react';

const UnknownErrorIcon = () => (
    <svg
        fill="none"
        height="106"
        viewBox="0 0 126 106"
        width="126"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M102.244 90.1667L88.0222 104.333L79.4889 95.8333L93.7111 81.6667L79.4889 67.5L88.0222 59L102.244 73.1667L116.467 59L125 67.5L110.778 81.6667L125 95.8333L116.467 104.333L102.244 90.1667Z"
            stroke="#8C969D"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
        <path
            d="M92.0002 53.4999L60.2293 4.15237C59.2751 2.59362 57.6721 1.83325 56.069 1.83325C54.466 1.83325 52.863 2.59362 51.9088 4.15237L1.83314 85.5876C-0.189736 88.8572 2.17664 93.0772 5.99338 93.0772H73.3894"
            stroke="#8C969D"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
        <path
            d="M56 68C53.7833 68 52 69.7833 52 72C52 74.2167 53.7833 76 56 76C58.2167 76 60 74.2167 60 72C60 69.7833 58.2 68 56 68Z"
            stroke="#8C969D"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
        <path
            d="M56.0011 61C57.8095 61 58.9112 59.9817 59.3269 58.4C59.7427 56.84 60.6157 46.0933 60.9899 40.395C61.1769 37.2317 58.7449 35 56.0011 35C53.2573 35 50.8045 37.2317 51.0123 40.395C51.3865 46.0933 52.2595 56.84 52.6752 58.4C53.091 59.9817 54.1927 61 56.0011 61Z"
            stroke="#8C969D"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
    </svg>
);

export default UnknownErrorIcon;
